<script src="../../../../../retailstore365_server/model/report.js"></script>
<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">


        <el-row>
            <el-col :span="24" :class="$style.body" class="subjectList">


                <el-form ref="form" label-width="80px">
                    <div :class="$style.wrap">
                        <el-form-item label="所属区域" prop="area">
                            <el-select v-model="region" clearable
                                       placeholder="选择区域" size="small" style="width: 230px;">
                                <el-option v-for="item in regionArray" :key="item.region_id"
                                           :label="item.region_name"
                                           :value="item.region_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="省份" prop="provinces">
                            <el-select v-model="provinces" v-on:change="handleProvincesClick" clearable
                                       placeholder="选择省份" size="small" style="width: 230px;">
                                <el-option v-for="item in provinceArray" :key="item.province_id"
                                           :label="item.province_name"
                                           :value="item.province_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="城市" prop="city">
                            <el-select v-model="city" clearable placeholder="选择城市" :disabled="isShowCity"
                                       size="small"
                                       style="width: 230px;">
                                <el-option v-for="item in selectCityArray" :key="item.city_id"
                                           :label="item.city_name"
                                           :value="item.city_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>


                <el-row>
                    <el-button type="success" size="mini" @click.stop="handleQueryClick">查询</el-button>
                    <el-button type="danger" size="mini" @click.stop="handleResetClick">重置</el-button>
                    <el-button type="primary" size="mini" icon="el-icon-upload2" style="float: right"
                               @click.stop="handleExportData">导出数据
                    </el-button>
                </el-row>

                <div :class="$style.border"></div>

                <div :class="$style.footer">
                    <div style="width: 100%">
                        <el-button-group :class="$style.month" class="a_modal">
                            <el-button size="small" icon="el-icon-arrow-left"
                                       @click.stop="lastNextMonthClick(-1)"></el-button>
                            <el-button size="small" disabled>{{dateStr}}</el-button>
                            <el-button size="small" icon="el-icon-arrow-right"
                                       @click.stop="lastNextMonthClick(1)"></el-button>
                        </el-button-group>
                    </div>

                    <div style="width: 100%">

                        <el-row style="margin-bottom: 15px;margin-top: 5px">
                            <el-col :span="24" :class="$style.text">
                                <div class="grid-content bg-purple" align="center">

                                    <span>排班工时：</span>
                                    <span style="color: #7ED321">{{scheduling_hours}}</span>
                                    <span :class="$style.span">小时</span>

                                    <span>迟到早退：</span>
                                    <span :class="$style.span_color">{{lateLeave_hours}}</span>
                                    <span :class="$style.span">小时</span>

                                    <span>缺勤时长：</span>
                                    <span :class="$style.span_color">{{absence_hours}}</span>
                                    <span :class="$style.span">小时</span>

                                    <span>请假(扣薪)：</span>
                                    <span :class="$style.span_color">{{leave_hours}}</span>
                                    <span :class="$style.span">小时</span>

                                    <span>带薪休假：</span>
                                    <span :class="$style.span_color">{{vacation_hours}}</span>
                                    <span :class="$style.span">小时</span>

                                    <span>加班工时：</span>
                                    <span style="color: #4A90E2">{{ot_hours}}</span>
                                    <span :class="$style.span">小时</span>

                                    <span>实际工时：</span>
                                    <span style="color: #4A90E2">{{actual_hours}}</span>
                                    <span :class="$style.span">小时</span>

                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <el-table
                            :data="tableData"
                            style="width: 100%"
                            :header-cell-style="tableHeaderColor">

                        <el-table-column type="expand">
                            <template slot-scope="props">

                                <el-form label-position="left" inline class="demo-table-expand">

                                    <el-form-item v-show="props.row.Child.length === 0">
                                        <span>暂无数据</span>
                                    </el-form-item>

                                    <el-col v-for="(item, index) in props.row.Child" :key="index" :label="item"
                                            :span="8"
                                            v-show="props.row.Child.length !== 0">
                                        <el-form-item>
                                            <div class="channel">

                                                <div>
                                                    <span style="display:-moz-inline-box; display:inline-block; min-width:40px;text-align: right;text-align: center">{{item.last_name}}</span>
                                                </div>


                                                <div style="margin-left: 15px;color: #B0B5B9">


                                                    <span>排班工时:</span>
                                                    <span style="display:-moz-inline-box; display:inline-block; width:40px;text-align: right;color: #7ED321">{{item.shift_hours}}</span>
                                                    <span>小时</span>

                                                    <span style="margin-left: 10px">实际工时:</span>
                                                    <span style="display:-moz-inline-box; display:inline-block; width:20px;text-align: right;color: #4A90E2">{{item.paid_hours}}</span>
                                                    <span>小时</span>


                                                    <div style="min-width:200px;max-width:300px;height:1px;margin-top:-5px;margin-bottom:-5px;padding:0px;background-color:#4D586D;overflow:hidden;"></div>
                                                    <span>迟到早退:</span>
                                                    <span style="display:-moz-inline-box; display:inline-block; width:40px;text-align: right">{{item.c_lateleave}}</span>
                                                    <span>小时</span>

                                                    <span style="margin-left: 10px">带薪休假:</span>
                                                    <span style="display:-moz-inline-box; display:inline-block; width:20px;text-align: right">{{item.paid_leave_hours}}</span>
                                                    <span>小时</span>


                                                    <div style="min-width:200px;max-width:300px;margin-top:-10px;margin-bottom:-10px;padding:0px;overflow:hidden;"></div>
                                                    <span>缺勤时长:</span>
                                                    <span style="display:-moz-inline-box; display:inline-block; width:40px;text-align: right">{{item.absence_hours}}</span>
                                                    <span>小时</span>

                                                    <span style="margin-left: 10px">加班工时:</span>
                                                    <span style="display:-moz-inline-box; display:inline-block; width:20px;text-align: right">{{item.ot_hours}}</span>
                                                    <span>小时</span>


                                                    <div style="min-width:200px;max-width:300px;margin-top:-10px;margin-bottom:-10px;padding:0px;overflow:hidden;"></div>
                                                    <span>请假(扣薪):</span>
                                                    <span style="display:-moz-inline-box; display:inline-block; width:32px;text-align: right">{{item.leave_hours}}</span>
                                                    <span>小时</span>

                                                    <span style="margin-left: 10px">三薪工时:</span>
                                                    <span style="display:-moz-inline-box; display:inline-block; width:20px;text-align: right">{{item.legal_vacation_hours}}</span>
                                                    <span>小时</span>

                                                </div>

                                            </div>

                                        </el-form-item>

                                    </el-col>

                                </el-form>


                            </template>
                        </el-table-column>

                        <el-table-column
                                label="区域"
                                prop="area"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                label="省份"
                                prop="province"
                                sortable
                                width="80">
                        </el-table-column>
                        <el-table-column
                                label="城市"
                                prop="city"
                                sortable
                                width="80">
                        </el-table-column>
                        <el-table-column
                                label="门店"
                                prop="name"
                                sortable
                                min-width="150">
                        </el-table-column>
                        <el-table-column
                                label="排班工时"
                                prop="scheduling"
                                sortable
                                align="center"
                                min-width="96">
                        </el-table-column>
                        <el-table-column
                                label="迟到早退"
                                prop="lateleave"
                                sortable
                                align="center"
                                min-width="96">
                        </el-table-column>
                        <el-table-column
                                label="缺勤时长"
                                prop="absence"
                                sortable
                                align="center"
                                min-width="96">
                        </el-table-column>
                        <el-table-column
                                label="请假(扣薪)"
                                prop="leave"
                                sortable
                                align="center"
                                min-width="110">
                        </el-table-column>
                        <el-table-column
                                label="带薪休假"
                                prop="vacation"
                                sortable
                                align="center"
                                min-width="96">
                        </el-table-column>
                        <el-table-column
                                label="加班工时"
                                prop="ot"
                                sortable
                                align="center"
                                min-width="96">
                        </el-table-column>
                        <el-table-column
                                label="三薪工时"
                                prop="legal"
                                sortable
                                align="center"
                                min-width="96">
                        </el-table-column>
                        <el-table-column
                                label="实际工时"
                                prop="actual"
                                sortable
                                align="center"
                                min-width="96">
                        </el-table-column>


                    </el-table>


                    <el-dialog
                            title="导出数据"
                            :visible.sync="dialogVisible"
                            width="35%"
                            :before-close="handleClose"
                            style="vertical-align: center;: #FFF9F3">
                        <div class="b_modal">
                            <el-button type="primary" @click.stop="handleExportDataByStore">门店汇总</el-button>

                            <el-button type="primary" @click.stop="handleExportDataByClerk">人员汇总</el-button>

                            <el-button type="primary" @click.stop="handleExportDataByDay">每日明细</el-button>
                        </div>
                    </el-dialog>
                </div>
            </el-col>
        </el-row>

    </div>
</template>
<script>
    import http from '../../../APIService/http'
    import moment from 'moment'

    export default {
        data() {
            return {
                loading: false,

                regionArray: [],
                provinceArray: [],
                cityArray: [],
                selectCityArray: [],

                region: '',
                provinces: '',
                city: '',


                id: '',
                dialogVisible: false,
                scheduling_hours: 0,
                lateLeave_hours: 0,
                absence_hours: 0,
                leave_hours: 0,

                vacation_hours: 0,
                ot_hours: 0,
                actual_hours: 0,

                date: moment(),
                dateStr: this.getCurrentDate(),
                tableData: []
            }
        },
        components: {},
        computed: {
            isShowCity() {
                if (this.provinces.length > 0) {
                    return false
                }
                return true
            },
        },
        created() {

            let obj = this.$store.getters.getStore
            this.title = obj.storeName

            this.id = this.$store.getters.getStore.id

            this.getWorkingHoursByday()
            this.getAreaCity()
        },
        methods: {

            // 返回按钮
            handleBackClick() {
                this.$router.push({
                    path: '/attendance'
                })
            },
            // 初始化页面获取数据
            async getWorkingHoursByday() {
                try {

                    this.loading = true
                    let data = {
                        region: this.region,
                        provinces: this.provinces,
                        city: this.city,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        month: this.date.format("YYYY-MM"),
                    }


                    await http.post('/wapi/v1/getReportWorkingHours', data).then(res => {


                        let data = res.data

                        let scheduling_info = res.data.scheduling_info

                        this.scheduling_hours = scheduling_info.scheduling_hours
                        this.lateLeave_hours = scheduling_info.lateLeave_hours
                        this.absence_hours = scheduling_info.absence_hours
                        this.leave_hours = scheduling_info.leave_hours
                        this.vacation_hours = scheduling_info.vacation_hours
                        this.ot_hours = scheduling_info.ot_hours
                        this.actual_hours = scheduling_info.actual_hours

                        this.tableData = data.result_array

                        this.loading = false


                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            async getAreaCity() {

                try {

                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    await http.post('/wapi/v1/getAreaCity', data).then(res => {

                        this.regionArray = res.data.regionArray
                        this.provinceArray = res.data.provinceArray
                        this.cityArray = res.data.cityArray


                    })

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            // 省份的改变
            handleProvincesClick() {
                this.city = ''
                this.selectCityArray = []
                this.cityArray.forEach(item => {
                    if (item.province_id === this.provinces) {
                        this.selectCityArray.push(item)
                    }
                })
            },
            // 查询
            handleQueryClick() {
                this.getWorkingHoursByday()
            },
            // 重置
            handleResetClick() {
                this.region = '',
                    this.provinces = '',
                    this.city = ''
            },
            // 修改table header的背景色
            tableHeaderColor({row, column, rowIndex, columnIndex}) {
                if (rowIndex === 0) {
                    return 'background-color: #E0E0E0;color: #5C575E;font-size: 13px';
                }
            },
            getCurrentDate() {

                let date = moment(this.date)
                return date.year() + '年' + this.getFormatDate(date.month() + 1) + '月'


            }, lastNextMonthClick(num) {

                let currentDate = moment(this.date)
                let date = currentDate.add(num, "months")
                this.date = date
                this.dateStr = date.year() + '年' + this.getFormatDate(date.month() + 1) + '月'

                this.getWorkingHoursByday()

            },
            getFormatDate(arg) {

                if (!arg) {
                    return '';
                }
                var re = arg + '';
                if (re.length < 2) {
                    re = '0' + re;
                }
                return re;
            },
            getFirstCheckIn(num, check) {
                if (num === 0) {

                    if (check) {
                        return check.substring(check.length - 8, check.length)
                    } else {
                        return '尚未签入'
                    }

                } else {
                    if (check) {
                        return check.substring(check.length - 8, check.length)
                    } else {
                        return '尚未签出'
                    }
                }
            },
            handleExportData() {
                this.dialogVisible = true
            },
            async handleExportDataByStore() {//门店汇总
                try {
                    this.loading = true

                    //工时统计表
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['区域', '省份', '城市', '门店', '排班工时', '迟到早退', '缺勤时长', '请假(扣薪)', '带薪休假', '加班工时', '三薪工时', '实际工时']
                        const filterVal = ['area', 'province', 'city', 'name', 'scheduling', 'lateleave', 'absence', 'leave', 'vacation', 'ot', 'legal', 'actual']
                        const list = this.tableData
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '工时统计(门店汇总)',
                            autoWidth: this.autoWidth
                        })

                    })


                    this.loading = false
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            async handleExportDataByClerk() {//人员汇总
                try {
                    this.loading = true

                    //店员工时统计表
                    let tableDataByClerk = []
                    for (let item of this.tableData) {

                        if (item.Child.length > 0) {

                            for (let childItem of item.Child) {

                                childItem.area = item.area
                                childItem.province = item.province
                                childItem.city = item.city
                                childItem.name = item.name

                                tableDataByClerk.push(childItem)
                            }
                        }
                    }


                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['区域', '省份', '城市', '门店', '店员', '排班工时', '迟到早退', '缺勤时长', '请假(扣薪)', '带薪休假', '加班工时', '三薪工时', '实际工时']
                        const filterVal = ['area', 'province', 'city', 'name', 'last_name', 'shift_hours', 'c_lateleave', 'absence_hours', 'leave_hours', 'paid_leave_hours', 'ot_hours', 'legal_vacation_hours', 'paid_hours']
                        const list = tableDataByClerk
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '工时统计(人员汇总)',
                            autoWidth: this.autoWidth
                        })

                    })


                    this.loading = false
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            async handleExportDataByDay() {//每日明细
                try {

                    this.loading = true
                    let data = {
                        user_id: this.$store.getters.getUser.user_id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        month: this.date.format("YYYY-MM"),
                    }

                    await http.post('/wapi/v1/getWorkingHoursInfoByDay', data).then(res => {


                        let tableData = res.data.schedule_array

                        import('@/vendor/Export2Excel').then(excel => {
                            const tHeader = ['区域', '省份', '城市', '门店', '日期', '排班工时', '迟到早退', '缺勤时长', '请假(扣薪)', '带薪休假', '加班工时', '三薪工时', '实际工时']
                            const filterVal = ['area', 'province', 'city', 'name', 'date', 'scheduling', 'lateleave', 'absence', 'leave', 'vacation', 'ot', 'legal', 'actual']
                            const list = tableData
                            const data = this.formatJson(filterVal, list)

                            excel.export_json_to_excel({
                                header: tHeader,
                                data,
                                filename: '工时统计(每日明细)',
                                autoWidth: this.autoWidth
                            })

                        })


                        this.loading = false


                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            handleClose(done) {
                // this.$confirm('确认关闭？')
                //     .then(_ => {
                //         done();
                //     })
                //     .catch(_ => {});
                done();
                // this.$forceUpdate()
            },
        }
    }
</script>
<style lang="scss" module>
    @import '../../../assets/css/default';

    .container {
        background: #fff;
        padding: 20px 20px;
        height: 100%;
        box-sizing: border-box;

        .body {

            .wrap {
                display: flex;
                justify-content: space-between;
                flex-wrap: nowrap;

            }
            .font {
                margin: 0 10px;
                font-size: $fontSize;
                color: #3b3b3e;
                text-align: left;
            }

            .border {
                border-bottom: 2px dashed #e7eaec;
                padding: 10px 0px;
            }

            .month {
                margin-top: 20px;
                margin-left: 40%;
                margin-bottom: 10px;
            }
            .text {
                font-size: 13px;
                color: #4D586D;
            }

            .span {
                display: inline-block;
                font-size: 12px;
                color: #FFFFFF;
                text-align: left;
                padding: 5px;
                background: #9B9B9B;
                border-radius: 3px;
                margin-left: 5px;
                margin-right: 5px;
            }
            .span_shift {
                font-size: 12px;
                color: #FFFFFF;
                text-align: center;
                padding: 5px;
                background: #9B9B9B;
                border-radius: 3px;
                margin-left: 5px;
                margin-right: 5px;
                max-width: 64px;
            }
            .span_color {
                color: #ED3B3F;
            }

            .demo-table-expand {
                font-size: 0;
            }
            .demo-table-expand label {
                width: 90px;
                color: #99a9bf;
            }
            .demo-table-expand .el-form-item {
                margin-right: 0;
                margin-bottom: 0;
                width: 100%;
            }
        }
    }
</style>
<style scoped>

    .a_modal >>> .el-button {
        color: #646464;
    }

    .channel {
        border: solid 1px #87909A;
        padding-left: 10px;
        padding-right: 10px;
        margin-left: -50px;
        font-size: 12px;
        border-radius: 4px;
        min-height: 58px;
        vertical-align: middle;

        /*display: flex;*/
        /*justify-content: space-around;*/
        display: flex;
        align-items: center;
        position: relative;
    }
    .b_modal{
        color: #ffffff;
        display: flex;
        justify-content: space-around;
        position: relative;
    }
    .subjectList >>> .el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }

</style>




// WEBPACK FOOTER //
// src/pages/report/workingHours/index.vue